"use client";

import { useState } from "react";

import type { ModalView } from "@/app/_components/my-enquiries/modal/enquiry-types";

export function useEnquiryModalView(initialView: ModalView = null) {
  const [modalView, setModalView] = useState<ModalView>(initialView);

  const openDetailsModal = () => setModalView("enquiry-detail");
  const closeModal = () => setModalView(null);

  return {
    modalView,
    setModalView,
    openDetailsModal,
    closeModal,
    isOpen: modalView !== null,
  };
}
